import React from "react";
import PropTypes from "prop-types";

const Span = ({ requestSort, type, getClassNamesFor, label }) => (
  <span
    type="button"
    onClick={() => requestSort(type)}
    className={`${getClassNamesFor(type)} btn-block`}
  >
    {label}
  </span>
);

Span.propTypes = {
  requestSort: PropTypes.func,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getClassNamesFor: PropTypes.func
};

export default Span;
